// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_intraday_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { BiddingIntradayService } from "./bidding_intraday_service_pb";

/**
 * 注文一覧。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.ListBiddingIntradayOrders
 */
export const listBiddingIntradayOrders = BiddingIntradayService.method.listBiddingIntradayOrders;

/**
 * 注文 1 件取得。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.GetBiddingIntradayOrder
 */
export const getBiddingIntradayOrder = BiddingIntradayService.method.getBiddingIntradayOrder;

/**
 * 注文を新規作成 (= 下書き状態)。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.CreateBiddingIntradayOrder
 */
export const createBiddingIntradayOrder = BiddingIntradayService.method.createBiddingIntradayOrder;

/**
 * 下書きの更新。 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.UpdateBiddingIntradayOrder
 */
export const updateBiddingIntradayOrder = BiddingIntradayService.method.updateBiddingIntradayOrder;

/**
 * 下書き状態の注文を削除。 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.DeleteBiddingIntradayOrder
 */
export const deleteBiddingIntradayOrder = BiddingIntradayService.method.deleteBiddingIntradayOrder;

/**
 * 注文 lifecycle の状態遷移 (= 承認申請 / 承認 / 差戻し / 申請取消 / JEPX 提出 / 取下 / 差戻し後再編集 を action で指定)。
 * 共通 BiddingLifecycleAction を使用 (= spot と共通、 ただし intraday は WITHDRAW も有効)。
 * 楽観ロック使用。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.TransitionBiddingIntradayOrderState
 */
export const transitionBiddingIntradayOrderState = BiddingIntradayService.method.transitionBiddingIntradayOrderState;

/**
 * 時間前入札 CSV のチェック (= 構文 + 業務検証 + 差分プレビュー、 副作用なし)。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.CheckBiddingIntradayOrderCsv
 */
export const checkBiddingIntradayOrderCsv = BiddingIntradayService.method.checkBiddingIntradayOrderCsv;

/**
 * 時間前入札 CSV の確定 (= check_token を引き換えて、 行ごとのエリアの承認モードどおりに
 * 承認申請または提出まで進める。 提出した札は JEPX へ送信される)。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.ApplyBiddingIntradayOrderCsv
 */
export const applyBiddingIntradayOrderCsv = BiddingIntradayService.method.applyBiddingIntradayOrderCsv;

/**
 * 手数料自動考慮 (時間前) の状態と、 希望価格から算出した入札価格を行ごとに返す
 * (intraday-bidding.md AC-BIN-004b / AC-BIN-104。 副作用なし)。 個別作成・一括作成・
 * 入札編集のモーダルが補足表示と値域・入札制限の判定に使う。 保存済みの入札価格から
 * 希望価格を逆算した値 (入札編集モーダルの初期値) も同じ呼び出しで返す。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.PreviewBiddingIntradayOrderFeeAdjustedPrices
 */
export const previewBiddingIntradayOrderFeeAdjustedPrices = BiddingIntradayService.method.previewBiddingIntradayOrderFeeAdjustedPrices;

/**
 * 受渡日の 48 コマそれぞれについて、 指定エリアにある自社の札のうち入札中
 * (intraday-bidding.md AC-BIN-035。 一部約定を含む) の件数を返す。 副作用なし。
 * 板発注画面の 48 コマリボン (AC-BIN-025) が使う。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.ListBiddingIntradayActiveOrderCounts
 */
export const listBiddingIntradayActiveOrderCounts = BiddingIntradayService.method.listBiddingIntradayActiveOrderCounts;

/**
 * フォーミュラ価格を、 呼び出した時点の変数の値で計算して返す (intraday-bidding.md
 * AC-BIN-005c のプレビュー。 副作用なし)。 変数の値が無い・計算できない時も RPC のエラーに
 * せず status で返す。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.PreviewBiddingIntradayOrderFormulaPrice
 */
export const previewBiddingIntradayOrderFormulaPrice = BiddingIntradayService.method.previewBiddingIntradayOrderFormulaPrice;

/**
 * 入札中の札を一括で板取消する (intraday-bidding.md AC-BIN-112)。 扱いは
 * internalapi.v1.IntradayOrderService.WithdrawIntradayOrders を参照。
 *
 * @generated from rpc bffuser.v1.BiddingIntradayService.WithdrawBiddingIntradayOrders
 */
export const withdrawBiddingIntradayOrders = BiddingIntradayService.method.withdrawBiddingIntradayOrders;
